// Pure helpers for the PWO/video close flows (AIT-246, AIT-274).

const CONTENT_MODULES = ["pwo", "video", "quiz"];

/**
 * Snapshot of the screen to return to after an auto-opened PWO/video closes.
 * Returns null when the current screen is itself a content screen (an auto
 * chain already in flight, or a follow-up asked from inside a scene), so the
 * original snapshot is never overwritten with a content module.
 */
export function captureAutoOpenReturn({ activeModule, learningSubModule, activeSidebarTab }) {
  if (!activeModule || CONTENT_MODULES.includes(activeModule)) return null;
  return Object.freeze({ activeModule, learningSubModule, activeSidebarTab });
}

/**
 * Where a close should land. A saved auto-open snapshot wins over the default
 * resolution; with no snapshot the default is returned untouched, so manual
 * opens behave exactly as before.
 */
export function resolveCloseDestination(saved, defaultModule) {
  if (saved && saved.activeModule) return saved.activeModule;
  return defaultModule;
}

/** True when a PWO or video is currently on screen. */
export function isPwoOrVideoOpen({ showVideo, showPwo, activeModule }) {
  return Boolean(showVideo || showPwo || activeModule === "pwo" || activeModule === "video");
}

/**
 * Whether a freshly synced Da Vinci challenge result must wait. While content is
 * open nothing may interrupt it; the result is parked and shown on close.
 */
export function shouldDeferChallengeReveal(contentState) {
  return isPwoOrVideoOpen(contentState);
}

/**
 * Translate a sync response into a reveal action, or null when there is
 * nothing to show.
 */
export function planChallengeReveal(data) {
  if (!data || data.just_completed_day == null) return null;
  if (data.all_done) return { type: "hub" };
  return {
    type: "modal",
    modal: {
      day: data.just_completed_day,
      nextDay: data.next_day,
      nextCollectionId: data.next_collection_id,
      allDone: false,
      cert: data.cert || null,
    },
  };
}
